import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "subflow-monitor-dropdown",
  "data-testid": "consult.subflow-monitor-list"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  class: "subflow-monitor-dropdown__type",
  "data-testid": "consult.subflow-monitor-type"
}
const _hoisted_4 = {
  key: 0,
  class: "sps-badge sps-badge-xs sps-badge-secondary subflow-monitor-dropdown__count",
  "data-testid": "consult.subflow-monitor-count"
}
const _hoisted_5 = {
  key: 0,
  class: "sps-alert sps-alert-light sps-alert-sm subflow-monitor-dropdown__empty",
  "data-testid": "consult.subflow-monitor-empty"
}
const _hoisted_6 = { class: "sps-alert-content" }
const _hoisted_7 = {
  key: 1,
  class: "sps-alert sps-alert-light sps-alert-sm sps-alert-success subflow-monitor-dropdown__complete",
  "data-testid": "consult.subflow-monitor-complete"
}
const _hoisted_8 = { class: "sps-alert-content" }

interface SubflowGroup {
    EntityId: number;
    EntityName: string;
    TypeId: number;
    TypeName: string;
    CompletionLifeStatusName: string;
    HasLinkedRecords: boolean;
    UnfinishedCount: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SubflowMonitorList',
  props: {
    groups: {},
    emptyText: { default: 'No linked records yet' },
    completeText: { default: 'All linked records complete' }
  },
  emits: ["show-records"],
  setup(__props: any) {

const props = __props;



const count = (group: SubflowGroup) => group.UnfinishedCount || 0;

const isBlocking = (group: SubflowGroup) => group.HasLinkedRecords && count(group) > 0;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.groups, (group, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["subflow-monitor-dropdown__group", { 'subflow-monitor-dropdown__group--complete': !isBlocking(group) }]),
        "data-testid": "consult.subflow-monitor-group"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["subflow-monitor-dropdown__entity", { 'subflow-monitor-dropdown__entity--clickable': count(group) > 0 }]),
          onClick: _withModifiers(($event: any) => (count(group) > 0 && _ctx.$emit('show-records', group)), ["stop"])
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(group.TypeName || group.EntityName), 1 /* TEXT */),
          (count(group) > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(count(group)), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ], 10 /* CLASS, PROPS */, _hoisted_2),
        (!group.HasLinkedRecords)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(__props.emptyText), 1 /* TEXT */)
            ]))
          : (!isBlocking(group))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(__props.completeText), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})